// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { adminSetEmailQueuesStatusRequestToJson, getBouncedRecipientRequestToJson, getBouncedRecipientResponseFromJson, getEmailDomainResponseFromJson, getPendingEmailDomainResponseFromJson, getUnsubscribedRecipientRequestToJson, getUnsubscribedRecipientResponseFromJson, initiateEmailDomainRectifyRequestToJson, initiateEmailDomainRollbackRequestToJson, listUnsubscribedRecipientsRequestToJson, listUnsubscribedRecipientsResponseFromJson, redirectEmailRequestToJson, redirectEmailResponseFromJson, resubscribeRecipientRequestToJson, unbounceRecipientRequestToJson, updateEmailDomainRequestToJson, updatePendingDomainRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function setEmailQueuesStatus(request) {
    await fetchRpc('email.v1.Admin/SetEmailQueuesStatus', adminSetEmailQueuesStatusRequestToJson(request));
}
export function setEmailQueuesStatus$(request, options) {
    return defer(() => setEmailQueuesStatusWithTransport$(getGlobalTransport(), request, options));
}
export function setEmailQueuesStatusWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/SetEmailQueuesStatus', adminSetEmailQueuesStatusRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function redirectEmail(request) {
    const raw = await fetchRpc('email.v1.Admin/RedirectEmail', redirectEmailRequestToJson(request));
    return redirectEmailResponseFromJson(raw);
}
export function redirectEmail$(request, options) {
    return defer(() => redirectEmailWithTransport$(getGlobalTransport(), request, options));
}
export function redirectEmailWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/RedirectEmail', redirectEmailRequestToJson(request), options)
        .pipe(map(resp => redirectEmailResponseFromJson(resp)));
}
export async function resubscribeRecipient(request) {
    await fetchRpc('email.v1.Admin/ResubscribeRecipient', resubscribeRecipientRequestToJson(request));
}
export function resubscribeRecipient$(request, options) {
    return defer(() => resubscribeRecipientWithTransport$(getGlobalTransport(), request, options));
}
export function resubscribeRecipientWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/ResubscribeRecipient', resubscribeRecipientRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getUnsubscribedRecipient(request) {
    const raw = await fetchRpc('email.v1.Admin/GetUnsubscribedRecipient', getUnsubscribedRecipientRequestToJson(request));
    return getUnsubscribedRecipientResponseFromJson(raw);
}
export function getUnsubscribedRecipient$(request, options) {
    return defer(() => getUnsubscribedRecipientWithTransport$(getGlobalTransport(), request, options));
}
export function getUnsubscribedRecipientWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/GetUnsubscribedRecipient', getUnsubscribedRecipientRequestToJson(request), options)
        .pipe(map(resp => getUnsubscribedRecipientResponseFromJson(resp)));
}
export async function initiateEmailDomainRollback(request) {
    await fetchRpc('email.v1.Admin/InitiateEmailDomainRollback', initiateEmailDomainRollbackRequestToJson(request));
}
export function initiateEmailDomainRollback$(request, options) {
    return defer(() => initiateEmailDomainRollbackWithTransport$(getGlobalTransport(), request, options));
}
export function initiateEmailDomainRollbackWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/InitiateEmailDomainRollback', initiateEmailDomainRollbackRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function initiateEmailDomainRectify(request) {
    await fetchRpc('email.v1.Admin/InitiateEmailDomainRectify', initiateEmailDomainRectifyRequestToJson(request));
}
export function initiateEmailDomainRectify$(request, options) {
    return defer(() => initiateEmailDomainRectifyWithTransport$(getGlobalTransport(), request, options));
}
export function initiateEmailDomainRectifyWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/InitiateEmailDomainRectify', initiateEmailDomainRectifyRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getBouncedRecipient(request) {
    const raw = await fetchRpc('email.v1.Admin/GetBouncedRecipient', getBouncedRecipientRequestToJson(request));
    return getBouncedRecipientResponseFromJson(raw);
}
export function getBouncedRecipient$(request, options) {
    return defer(() => getBouncedRecipientWithTransport$(getGlobalTransport(), request, options));
}
export function getBouncedRecipientWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/GetBouncedRecipient', getBouncedRecipientRequestToJson(request), options)
        .pipe(map(resp => getBouncedRecipientResponseFromJson(resp)));
}
export async function unbounceRecipient(request) {
    await fetchRpc('email.v1.Admin/UnbounceRecipient', unbounceRecipientRequestToJson(request));
}
export function unbounceRecipient$(request, options) {
    return defer(() => unbounceRecipientWithTransport$(getGlobalTransport(), request, options));
}
export function unbounceRecipientWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/UnbounceRecipient', unbounceRecipientRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listUnsubscribedRecipients(request) {
    const raw = await fetchRpc('email.v1.Admin/ListUnsubscribedRecipients', listUnsubscribedRecipientsRequestToJson(request));
    return listUnsubscribedRecipientsResponseFromJson(raw);
}
export function listUnsubscribedRecipients$(request, options) {
    return defer(() => listUnsubscribedRecipientsWithTransport$(getGlobalTransport(), request, options));
}
export function listUnsubscribedRecipientsWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/ListUnsubscribedRecipients', listUnsubscribedRecipientsRequestToJson(request), options)
        .pipe(map(resp => listUnsubscribedRecipientsResponseFromJson(resp)));
}
export async function updatePendingDomain(request) {
    const raw = await fetchRpc('email.v1.Admin/UpdatePendingDomain', updatePendingDomainRequestToJson(request));
    return getPendingEmailDomainResponseFromJson(raw);
}
export function updatePendingDomain$(request, options) {
    return defer(() => updatePendingDomainWithTransport$(getGlobalTransport(), request, options));
}
export function updatePendingDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/UpdatePendingDomain', updatePendingDomainRequestToJson(request), options)
        .pipe(map(resp => getPendingEmailDomainResponseFromJson(resp)));
}
export async function updateEmailDomain(request) {
    const raw = await fetchRpc('email.v1.Admin/UpdateEmailDomain', updateEmailDomainRequestToJson(request));
    return getEmailDomainResponseFromJson(raw);
}
export function updateEmailDomain$(request, options) {
    return defer(() => updateEmailDomainWithTransport$(getGlobalTransport(), request, options));
}
export function updateEmailDomainWithTransport$(transport, request, options) {
    return transport
        .post('email.v1.Admin/UpdateEmailDomain', updateEmailDomainRequestToJson(request), options)
        .pipe(map(resp => getEmailDomainResponseFromJson(resp)));
}
